import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// i18n must be initialised before any component calls useTranslation().
import '@doccareplus/i18n'
import '@doccareplus/ui/styles/tokens.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
